import React from "react";

/**
 * Shared sort arrows (▲ ▼) for report table headers.
 * Use with sortBy/sortOrder or sortField/sortOrder state; same UI across all reports.
 * @param {string} field - Column field name (e.g. "revenue", "searchQuery")
 * @param {string} activeSortField - Current sort field (sortBy or sortField from state)
 * @param {string} sortOrder - "asc" | "desc"
 * @param {function} onSort - (field, order, e?) => void
 */
const ReportSortArrows = ({ field, activeSortField, sortOrder, onSort }) => {
	const isActive = activeSortField === field;
	const upActive = isActive && sortOrder === "asc";
	const downActive = isActive && sortOrder === "desc";
	const arrowStyle = (active) => ({
		cursor: "pointer",
		fontSize: "10px",
		color: active ? "#000" : "#bbb",
		userSelect: "none",
		lineHeight: 1,
	});

	return (
		<span
			className="report-sort-arrows d-inline-flex flex-column align-items-center justify-content-center ms-1"
			style={{ lineHeight: 1, flexShrink: 0 }}
		>
			<span
				role="button"
				tabIndex={0}
				title="Sort ascending"
				onClick={(e) => {
					e?.stopPropagation?.();
					onSort(field, "asc", e);
				}}
				onKeyDown={(e) => e.key === "Enter" && onSort(field, "asc", e)}
				style={arrowStyle(upActive)}
				aria-label="Sort ascending"
			>
				▲
			</span>
			<span
				role="button"
				tabIndex={0}
				title="Sort descending"
				onClick={(e) => {
					e?.stopPropagation?.();
					onSort(field, "desc", e);
				}}
				onKeyDown={(e) => e.key === "Enter" && onSort(field, "desc", e)}
				style={arrowStyle(downActive)}
				aria-label="Sort descending"
			>
				▼
			</span>
		</span>
	);
};

export default ReportSortArrows;
